import React from "react";

interface SmartPredictSvgProps {
    width?: string;
    height?: string;
}

type Props = SmartPredictSvgProps;

const SmartPredictSvg: React.FC<Props> = ({ width, height }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width ?? "20"}
            height={height ?? "20"}
            viewBox="0 0 20 20"
            fill="none"
        >
            <path
                d="M10 0C4.478 0 0 4.4768 0 10C0 15.5232 4.478 20 10 20C15.522 20 20 15.5232 20 10C20 4.4768 15.5232 0 10 0ZM15.6652 12.552C15.9968 11.7344 16.16 10.8572 16.16 10C16.16 9.1428 16.0044 8.3032 15.6856 7.5012L16.7828 6.8704C17.1896 7.8332 17.4064 8.8964 17.4064 9.9996C17.4064 11.1028 17.1808 12.2064 16.7588 13.1832L15.6652 12.552ZM15.5548 4.9008C15.79 5.1688 16.0036 5.454 16.1968 5.7544L15.1072 6.3812C14.2068 5.0064 12.7116 3.9684 10.5676 3.7764V2.5244C12.6012 2.6796 14.3176 3.4932 15.5548 4.9008ZM8.944 11.2104C8.82 10.8284 6.2292 10.4664 6.228 10C6.2256 9.536 8.8228 9.1716 8.944 8.7896L9.7664 6.3936C9.8328 6.1764 10.1684 6.174 10.2348 6.3936C10.3108 6.4904 11.0244 9.0104 11.2104 8.944L13.6064 9.7652C13.8236 9.8316 13.826 10.1684 13.6064 10.2348C13.5096 10.3108 10.9896 11.0244 11.0572 11.2104C9.9064 14.6228 10.0968 14.6356 8.944 11.2104ZM9.5524 2.516V3.7672C7.3628 3.9284 5.8364 4.9632 4.9172 6.346L3.828 5.7168C4.014 5.4308 4.2196 5.1584 4.4448 4.902C5.7068 3.466 7.4668 2.648 9.5524 2.516ZM2.5948 10.0012C2.5948 8.8804 2.8184 7.8004 3.238 6.826L4.3328 7.4584C4.0032 8.2728 3.8412 9.1464 3.8412 10.0004C3.8412 10.8544 4.002 11.7236 4.3304 12.5364L3.2356 13.1688C2.818 12.196 2.5948 11.1196 2.5948 10.0012ZM4.4452 15.0992C4.2192 14.8416 4.0128 14.5672 3.8256 14.2788L4.914 13.65C5.8332 15.0348 7.3608 16.0716 9.5528 16.2328V17.484C7.468 17.352 5.708 16.5352 4.4452 15.0992ZM10.568 17.4756V16.2236C12.6896 16.0336 14.1756 15.0156 15.0788 13.6632L16.1672 14.2916C15.9828 14.5748 15.7792 14.8448 15.556 15.0976C14.318 16.506 12.6008 17.3212 10.568 17.4756Z"
                fill="#32D1B7"
            />
        </svg>
    );
};

export default SmartPredictSvg;
